module.exports = __webpack_public_path__ + "img/pic_face_man@2x.4553336e.png";